/**
 * @param {('initials'|'firstName'|'displayName')} detailToFormat
 * @param {object} user Sapling user
 * @return {string}
 */
export default function formatUser(detailToFormat, user) {
  if (!user) return '';
  const userValidName = getUserValidName(user);
  if (!userValidName) return '';
  if (detailToFormat === 'displayName') return userValidName;
  if (detailToFormat === 'initials') return user.userInitials || formatUserInitials(userValidName);
  if (detailToFormat === 'firstName') return formatUserFirstName(userValidName);
}

export function formatUserInitials(name) {
  const names = name.trim().split(' ');
  const firstInitial = names[0].charAt(0).toUpperCase();
  if (names.length === 1) return firstInitial;
  const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
  return `${firstInitial}${lastInitial}`;
}

function formatUserFirstName(name) {
  return name.trim().split(' ')[0];
}

function getUserValidName({ preferredFullName, preferredName, displayName, firstName, lastName }) {
  if (displayName) return displayName;
  if (preferredFullName) return preferredFullName;
  if (preferredName && lastName) return `${preferredName} ${lastName}`;
  if (firstName && lastName) return `${firstName} ${lastName}`;
  return false;
}
